module.exports = __webpack_public_path__ + "img/turbo_off.cc395380.png";